module.exports = __webpack_public_path__ + "img/photo.f5b01524.png";